<template>
    <main-layout>
        <app-header icon="calend">
            Planning
        </app-header>

        <div class="cols nav-planning" style="margin-bottom: 10px;">
            <button id="prevDay">
                <strong>Précédent</strong>
            </button>

            <button id="nextDay">
                <strong>Suivant</strong>
            </button>

            <router-link class="btn btn-full" :to="{name: 'liste-agenda'}" style="width: 100%;margin: 0 4px;padding: 0 25px;">
                <strong>Liste</strong>
            </router-link>
        </div>


        <template>
            <calendar
                  ref="tuiCalendar"
                  style="height: 800px;"
                  :schedules="scheduleList"
                  :view="view"
                  :taskView="taskView"
                  :scheduleView="scheduleView"
                  :theme="theme"
                  :disableDblClick="disableDblClick"
                  :isReadOnly="isReadOnly"
                  :template="template"
                  :useCreationPopup="useCreationPopup"
                  :useDetailPopup="useDetailPopup"
            />
        </template>

    </main-layout>
</template>

<script>

import { Calendar } from '@toast-ui/vue-calendar';
import $ from 'jquery'
import Planning from "../../js/models/Planning";
import localforage from "localforage";

export default {


    name: 'myCalendar',
    components: {
        'calendar': Calendar
    },

    data() {
        return {
            callCalendar: null,
            scheduleList: [],
            usageStatistics: false,
            view: 'day',
            taskView: false,
            scheduleView: ['time', 'allday'],
            theme: {
                'month.dayname.height': '30px',
                'month.dayname.borderLeft': '1px solid #ff0000',
                'month.dayname.textAlign': 'center',
                'week.today.color': '#333',
                'week.daygridLeft.width': '100px',
            },
            disableDblClick: true,
            isReadOnly: true,
            template: {
                timegridDisplayPrimayTime: function(time) {
                    return time.hour + 'h00';
                },
                timegridCurrentTime: function(timezone) {
                    return (timezone.hourmarker).getHours() + 'h' +  ('0' + (timezone.hourmarker).getMinutes()).slice(-2);
                },
                weekDayname: function (dayname) {
                    let date = new Date(dayname.renderDate)
                    return '<span class="calendar-week-dayname-name" style="font-size: 20px">' + Planning.daysFR(dayname.dayName) + ' ' + ('0' + dayname.date).slice(-2) + ' ' + Planning.monthsFR(date.getMonth()) + ' ' + date.getFullYear() + '</span>';
                },
                alldayTitle: function() {
                    return '<span class="tui-full-calendar-left-content" style="font-size: 14px"><strong>Journée entière</strong></span>';
                }

            },
            useCreationPopup: false,
            useDetailPopup: false,
        }
    },

    methods: {

        getEvents() {
            localforage
                .getItem('listEvents')
                .then(events => {
                    this.scheduleList = JSON.parse(events);
                }).catch(err => {
            })
        }

    },

    mounted() {
        //this.$refs.tuiCalendar.invoke('clear');
        let cal = this.$refs.tuiCalendar;

        let url = new URL(document.location.href);
        //["#/agenda","date=XXXX-XX-XX"]
        let urlSplit = url.hash.split('?');
        if(urlSplit.length > 1){
            let date = ((((urlSplit[1]).split('date='))[1]).split('T'))[0];
            cal.invoke('setDate', date);
        }




        $('#prevDay').click(function (){
           cal.invoke('prev');
        });

        $('#nextDay').click(function (){
            cal.invoke('next');
        })

        $('#app').on('click', '.tui-full-calendar-time-schedule-content-time, .tui-full-calendar-weekday-schedule-title', function (){
            let idEvent = $(this).parents('.tui-full-calendar-time-date-schedule-block').find('.tui-full-calendar-time-schedule').data('schedule-id');

            if(typeof idEvent == "undefined"){
                //Alors on regarde la journée entière et pas un event du jour..
                //tui-full-calendar-weekday-schedule-block
                idEvent = $(this).parents('.tui-full-calendar-weekday-schedule-block').find('.tui-full-calendar-weekday-schedule').data('schedule-id');
            }

            async function getInfoEvent(){
                let infoEvent = JSON.parse(await localforage.getItem('listEvents')).filter(event => {
                    if (event.id === idEvent)  {
                        return event
                    }
                });

                infoEvent = infoEvent[0];

                let now = new Date();
                let start = new Date(infoEvent.start);
                let end = new Date(infoEvent.end);


                if(infoEvent.body !== "" && (start < now && end < now)){
                    swal('Commentaire', infoEvent.body);
                }else{
                    document.location.href = "/#/liste-agenda"
                }

            }

            /*Fonctionnes sur l'API mais latence...
            async function getInfoEvent(){
                let api = await Api.init();
                api
                    .get(`planning/events/${idEvent}`)
                    .then(res => {
                        let body = res.data.body;

                        swal('Commentaire', body);
                    })
                    .catch()

            }


            */

            getInfoEvent();


        })


        this.getEvents();

    }
}

</script>

<style>
    @import "https://cdnjs.cloudflare.com/ajax/libs/tui-calendar/1.14.1/tui-calendar.css";

    .tui-full-calendar-timegrid-hour {
        font-size: 18px;
    }

    .tui-full-calendar-timegrid-hourmarker-time {
        font-size: 18px !important;
    }

    .cols {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .nav-planning button {
        width: 100%;
        margin: 0 4px;
    }

    .tui-full-calendar-time-schedule-content-time {
        font-size: 16px;
    }

    .tui-full-calendar-weekday-schedule-title {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// Agenda.vue?084d338a